import { Component, Input, OnInit } from '@angular/core';
import { Colaborador } from 'src/app/models/colaborador';
import { CHANGE_REQUEST_TYPE } from 'src/app/models/request-change';
import { Setor } from 'src/app/models/setor';
import { TipoSolicitacao } from 'src/app/models/solicitacao-troca';
import { Turno } from 'src/app/models/turno';

@Component({
  selector: 'scale-change-request-item',
  templateUrl: './scale-change-request-item.component.html',
  styleUrls: ['./scale-change-request-item.component.scss'],
})
export class ScaleChangeRequestItemComponent  implements OnInit {

  @Input() turno!: Turno | null;
  @Input() setor!: Setor | null;
  @Input() colaborador!: Colaborador | null;
  @Input() tipo!: TipoSolicitacao;
  @Input() dataTroca!: string;
  @Input() direction: 'to' | 'from' = 'to';

  change_request_type = CHANGE_REQUEST_TYPE;

  constructor() { }

  ngOnInit() {}

}
